"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var moment = require("moment");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var MemberList_1 = require("components/MemberList");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var userGroups_1 = require("utils/userGroups");
var CreateGroup_1 = require("../Modal/CreateGroup");
var EditGroup_1 = require("../Modal/EditGroup");
var MoveUserToGroup_1 = require("../Modal/MoveUserToGroup");
var LinkCustomerGroupModal_1 = require("../Modal/LinkCustomerGroupModal");
var customerUserGroupsActions = require("@caddigital/sok-reducers/lib/actions/project/customerUserGroups");
var projectMembersActions = require("@caddigital/sok-reducers/lib/actions/project/members");
var members_1 = require("@caddigital/sok-reducers/lib/reducers/project/members");
var userSettingsActions = require("@caddigital/sok-reducers/lib/actions/user/userSettings");
var toastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var GenericInviteModal_1 = require("components/modals/GenericInviteModal");
var Icon_1 = require("components/Icon");
var constants_1 = require("utils/constants");
require("./styles.scss");
var CreateItemDropDown_1 = require("./CreateItemDropDown");
var userGroupsExtractor_1 = require("../../../../utils/userGroupsExtractor");
var mapStateToProps = function (state) {
    return {
        members: state.project.members,
        searchString: state.project.members.searchString,
        currentUser: state.auth.current.user,
        activatedForms: state.sokosite.activatedForms.activatedForms.map(function (form) { return form.name; })
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    clear: function () { return dispatch(projectMembersActions.clearState()); },
    // Category & user profile
    toggleModal: function () { return dispatch(projectMembersActions.toggleModal()); },
    openEditCategoryModal: function (name, description, id) { return function () {
        return dispatch(projectMembersActions.modifyProjectUserGroup('EDIT', 'CATEGORY', name, description, id));
    }; },
    openEditUserProfileModal: function (name, description, id, validSince, validUntil) {
        return dispatch(projectMembersActions.modifyProjectUserGroup('EDIT', 'USER_PROFILE', name, description, id, validSince, validUntil));
    },
    openUserProfileModal: function (mode, type, name, description, id, validSince, validUntil, siteNumber) {
        if (name === void 0) { name = ''; }
        if (description === void 0) { description = ''; }
        if (id === void 0) { id = -1; }
        return dispatch(projectMembersActions.modifyProjectUserGroup(mode, type, name, description, id, validSince, validUntil, siteNumber));
    },
    toggleMoveUserToGroupModal: function (type) {
        return dispatch(projectMembersActions.moveCopyUserToGroup(type));
    },
    saveMoveUsersToGroup: function (project) {
        return function (users, group) {
            var x = users.map(function (y) { return ({ user: y.id, oldGroup: y.profile }); });
            dispatch(projectMembersActions.moveCopyUsersToGroupSaveRequest(project.id, x, group));
        };
    },
    deleteUsers: function (project, group, x) {
        return dispatch(projectMembersActions.deleteUsersRequest(project.id, [
            { user: x.id, group: group }
        ]));
    },
    deleteGroupsUsers: function (project, users) {
        return dispatch(projectMembersActions.deleteGroupsUsersRequest(project.id, users));
    },
    // User invite
    updateSelectedEmail: function (uuid, emails) {
        return dispatch(projectMembersActions.updateUserGroupEmail(uuid, emails));
    },
    updateSelectedGroup: function (uuid, newId, name) {
        return dispatch(projectMembersActions.updateUserGroupSelectBox(uuid, newId, name));
    },
    fetchProjectUserGroups: function (id) {
        return dispatch(projectMembersActions.UsergroupList.fetchRequest('PROJECT', id));
    },
    // Selections
    collapseUserRow: function (id, isCollapsed) {
        return dispatch(projectMembersActions.UsergroupList.collapseUserRow(id, isCollapsed));
    },
    addNewToast: function (title, message, type) {
        return dispatch(toastActions.addNewToast(title, message, type));
    },
    setGroupsSelected: function (items, selected) {
        return dispatch(projectMembersActions.UsergroupList.setGroupsSelected(items, selected));
    },
    setUsersSelected: function (items, selected) {
        return dispatch(projectMembersActions.UsergroupList.setUsersSelected(items, selected));
    },
    setSortingSelector: function (sortBy) {
        dispatch(projectMembersActions.UsergroupList.setSortingSelector(sortBy));
    },
    searchGroups: function (value) {
        return dispatch(projectMembersActions.UsergroupList.searchGroups(value));
    },
    openUserSettingsModal: function (user, projectId, level) {
        return dispatch(userSettingsActions.openUserSettingsModal(user, level !== 'NormalUserGroup' ? 'ADMIN' : 'USER', [projectMembersActions.UsergroupList.fetchRequest('PROJECT', projectId)]));
    },
    toggleInviteModal: function () {
        return dispatch(projectMembersActions.UsergroupInvite.inviteToggleModal());
    },
    selectItem: function (uuid, itemId) {
        return dispatch(projectMembersActions.UsergroupInvite.inviteSelectItem(uuid, itemId));
    },
    addNewRow: function (item) {
        return dispatch(projectMembersActions.UsergroupInvite.addRow(item.uuid, item.group, item.emails, item.language));
    },
    updateEmails: function (uuid) { return function (email) {
        return dispatch(projectMembersActions.UsergroupInvite.updateEmails(uuid, email));
    }; },
    updateLanguage: function (uuid, language) {
        return dispatch(projectMembersActions.UsergroupInvite.UpdateLanguage(uuid, language));
    },
    sendInvitations: function (inviteRows, project) {
        return function () {
            return dispatch(projectMembersActions.UsergroupInvite.inviteRequest(inviteRows, [
                projectMembersActions.UsergroupList.fetchRequest('PROJECT', project.id)
            ]));
        };
    },
    removeRow: function (uuid) {
        return dispatch(projectMembersActions.UsergroupInvite.removeRow(uuid));
    },
    setFeature: function (feature, status) {
        return dispatch(projectMembersActions.setFeature(feature, status));
    },
    deleteGroup: function (project, group) {
        return dispatch(projectMembersActions.deleteGroupRequest(project.id, group));
    },
    editGroup: function (group) {
        switch (group.type) {
            case 'WorksiteDiaryUserGroup':
            case 'TRMVRUserGroup': {
                var regexp = /^(.+) \((\d+)\)$/;
                var matches = regexp.exec(group.name) || [];
                var siteName = void 0, siteNumber = void 0;
                if (matches.length === 3) {
                    siteName = matches[1];
                    siteNumber = matches[2];
                }
                else {
                    siteName = group.name;
                }
                dispatch(projectMembersActions.modifyProjectUserGroup('EDIT', group.type === 'WorksiteDiaryUserGroup'
                    ? 'WORKSITE_DIARY'
                    : group.meterType === 'TRMETER'
                        ? 'TRMETER'
                        : 'MVRMETER', siteName, group.description || '', group.id, undefined, undefined, siteNumber));
                break;
            }
            case 'LightAdminUserGroup': {
                dispatch(projectMembersActions.modifyProjectUserGroup('EDIT', 'LIGHT_ADMIN', group.name, group.description || '', group.id, undefined, undefined, undefined, group.inviteRightsTo));
                break;
            }
            case 'CategoryUserGroup': {
                dispatch(projectMembersActions.modifyProjectUserGroup('EDIT', 'CATEGORY', group.name, group.description || '', group.id));
                break;
            }
            case 'NormalUserGroup': {
                dispatch(projectMembersActions.modifyProjectUserGroup('EDIT', 'USER_PROFILE', group.name, group.description || '', group.id, group.validSince !== undefined
                    ? moment(group.validSince)
                    : undefined, group.validUntil !== undefined
                    ? moment(group.validUntil)
                    : undefined));
                break;
            }
            case 'SokoBidUserGroup': {
                dispatch(projectMembersActions.modifyProjectUserGroup('EDIT', 'SOKOBID', group.name, group.description || '', group.id));
                break;
            }
        }
    },
    toggleLinkCustomerGroupModal: function () {
        return dispatch(customerUserGroupsActions.toggleModal());
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#endregion
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('TeamMembersUsers'), (0, recompose_1.withState)('warningModal', 'setWarningModal', null), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), recompose_1.pure);
function removeFromProject(props, accessibleCategories) {
    var _a = (0, userGroupsExtractor_1.userGroupsExtractor)(props.members, accessibleCategories), groupMap = _a[0], groups = _a[1];
    var selected = Object.values(groups).reduce(function (acc, x) { return acc.concat(x); }, []);
    var content = [
        (0, translation_1.getLocalization)('userfront/project/teamMembers/confirmDeleteSelected')
    ];
    if (acl.isProjectAdmin(props.currentProject.perm) &&
        !acl.isSokoBidAdmin(props.currentProject.perm) &&
        (groupMap['SokoBidUserGroup'] || groupMap['SokoBidAdminUserGroup'])) {
        content.push((0, translation_1.getLocalization)('userfront/project/teamMembers/confirmDeleteCategory/sokobidNotification'));
    }
    if (groupMap['CustomerUserGroup']) {
        content.push((0, translation_1.getLocalization)('userfront/project/teamMembers/confirmDeleteCategory/customerGroupNotification'));
    }
    props.setWarningModal({
        title: (0, translation_1.getLocalization)('userfront/project/teamMembers/confirmDelete'),
        content: content,
        action: function () { return props.deleteGroupsUsers(props.currentProject, selected); }
    });
}
var timeout = null;
var FilterEnhance = (0, recompose_1.compose)((0, recompose_1.withState)('search', 'setSearch', null), recompose_1.pure);
var FilterRow = FilterEnhance(function (props) {
    var allFeatures = props.featureFilter.length === members_1.defaultFilters.length;
    return (React.createElement("div", { className: 'filter-row' },
        React.createElement(sok_ui_1.Dropdown2, null,
            React.createElement(sok_ui_1.Button, { icon: React.createElement(Icon_1.Icon, { className: 'fa-eye' }), iconRight: React.createElement(Icon_1.Icon, { className: 'fa-chevron-down' }), size: 'large', color: 'dark-gray', text: (0, translation_1.getLocalization)('project/teamMembers/features') }),
            React.createElement(sok_ui_1.Dropdown2Menu, null,
                React.createElement(sok_ui_1.ClickWall, null,
                    React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () { return props.setFeature(members_1.defaultFilters, !allFeatures); } },
                        React.createElement("span", null,
                            React.createElement(Icon_1.Icon, { className: allFeatures ? 'fa-check-square' : 'fa-square', prefix: 'far' }),
                            ' ',
                            (0, translation_1.getLocalization)("project/teamMembers/features/showAll"))),
                    members_1.defaultFilters.reduce(function (acc, x) {
                        var enabled = props.featureFilter.includes(x);
                        switch (x) {
                            case 'FILESTAB':
                                if ((props.currentProject.perm & acl.FILESTAB_PERM) === 0) {
                                    return acc;
                                }
                                break;
                            case 'FILESTAB_PLUS':
                                if ((props.currentProject.perm & acl.FILESTAB_PLUS_PERM) ===
                                    0) {
                                    return acc;
                                }
                                break;
                            case 'SOKOBID':
                                if ((props.currentProject.perm & acl.SOKOBID_PERM) === 0) {
                                    return acc;
                                }
                                break;
                            case 'SOKOSITE':
                                if ((props.currentProject.perm & acl.SOKOSITE_PERM) === 0) {
                                    return acc;
                                }
                                break;
                        }
                        acc.push(React.createElement(sok_ui_1.Dropdown2MenuItem, { key: x, onClick: function () { return props.setFeature([x], !enabled); } },
                            React.createElement("span", null,
                                React.createElement(Icon_1.Icon, { className: enabled ? 'fa-check-square' : 'fa-square', prefix: 'far' }),
                                ' ',
                                (0, translation_1.getLocalization)("features/".concat(x, "/name")))));
                        return acc;
                    }, [])))),
        React.createElement(sok_ui_1.TextInput, { icon: React.createElement(Icon_1.Icon, { className: 'fa-search' }), iconRight: props.searchString.length > 0 ? (React.createElement(Icon_1.Icon, { className: 'fa-times clear-search', onClick: function () {
                    if (timeout) {
                        clearTimeout(timeout);
                    }
                    props.setSearch(null);
                    props.searchGroups('');
                } })) : undefined, placeholder: (0, translation_1.getLocalization)('userfront/project/teamMembers/searchPlaceholder'), value: props.search !== null ? props.search : props.searchString, onChange: function (e) {
                var value = e.target.value;
                props.setSearch(value);
                if (timeout) {
                    clearTimeout(timeout);
                }
                if (value === '') {
                    props.setSearch(null);
                    props.searchGroups(value);
                    return;
                }
                timeout = setTimeout(function () {
                    props.searchGroups(value);
                    props.setSearch(null);
                }, constants_1.SEARCH_TIMEOUT);
            } })));
});
var hasAnyOfGrants = function (perm, grants) {
    return grants.some(function (grant) { return (perm & grant) > 0; });
};
exports.default = enhance(function (props) {
    var accessibleCategories = (0, userGroups_1.getAccessibleCategories)(props.currentProject.perm, props.members.groups);
    var removeAccessibleCategories = (0, userGroups_1.getRemoveAccessibleCategories)(props.currentProject.perm, props.members.groups);
    var message = (React.createElement(React.Fragment, null,
        React.createElement("li", null,
            " ", "".concat((0, translation_1.getLocalization)('invite/member/info')),
            " "),
        React.createElement("li", null,
            " ", "".concat((0, translation_1.getLocalization)('invite/member/info/second')),
            " "),
        React.createElement("li", null,
            " ", "".concat((0, translation_1.getLocalization)('invite/member/info/third')),
            " ")));
    return (React.createElement("div", { className: 'sok-usergroups-content' },
        React.createElement("div", { className: 'buttons' },
            React.createElement(sok_ui_1.Button, { size: 'large', icon: React.createElement(Icon_1.Icon, { key: 'invite-icon', className: 'fa-user-plus' }), onClick: props.toggleInviteModal, color: 'base-green', className: 'text-left', text: (0, translation_1.getLocalization)('userfront/project/teamMembers/inviteToProject') }),
            hasAnyOfGrants(props.currentProject.perm, [
                acl.PROJECT_ADMIN_GRANT,
                acl.SOKOBID_ADMIN_GRANT
            ]) && (React.createElement(CreateItemDropDown_1.CreateItemDropDown, { text: (0, translation_1.getLocalization)('project/teamMembers/createNew'), currentProject: props.currentProject, activatedForms: props.activatedForms, openUserProfileModal: props.openUserProfileModal })),
            hasAnyOfGrants(props.currentProject.perm, [
                acl.CUSTOMER_ADMIN_GRANT
            ]) && (React.createElement(sok_ui_1.Button, { size: 'large', icon: React.createElement(Icon_1.Icon, { key: 'link-customer-group-icon', className: 'far fa-link' }), color: 'blue', className: 'text-left', text: (0, translation_1.getLocalization)('userfront/project/teamMembers/linkCustomerGroup'), onClick: function () { return props.toggleLinkCustomerGroupModal(); } })),
            React.createElement(sok_ui_1.Button, { size: 'large', disabled: props.members.selectedUsers.length === 0 ||
                    props.members.selectedUsers.every(function (x) {
                        return x.group.type === 'CustomerUserGroup' ||
                            x.group.type === 'CustomerCategoryUserGroup';
                    }), icon: React.createElement(Icon_1.Icon, { key: 'create-user-icon', className: 'far fa-arrows-alt' }), color: 'green', className: 'text-left', text: (0, translation_1.getLocalization)('userfront/project/teamMembers/moveUserToGroup'), onClick: function () { return props.toggleMoveUserToGroupModal('MOVE'); } }),
            React.createElement(sok_ui_1.Button, { size: 'large', disabled: props.members.selectedUsers.length === 0, icon: React.createElement(Icon_1.Icon, { key: 'create-user-icon', className: 'far fa-copy' }), color: 'base-green', className: 'text-left', text: (0, translation_1.getLocalization)('userfront/project/teamMembers/copyToGroup'), onClick: function () { return props.toggleMoveUserToGroupModal('COPY'); } }),
            hasAnyOfGrants(props.currentProject.perm, [
                acl.PROJECT_ADMIN_GRANT,
                acl.SOKOBID_ADMIN_GRANT
            ]) && (React.createElement(sok_ui_1.Button, { size: 'large', disabled: props.members.selectedUsers.length === 0 ||
                    props.members.selectedUsers.every(function (x) {
                        return x.group.type === 'CustomerUserGroup' ||
                            x.group.type === 'CustomerCategoryUserGroup';
                    }), icon: React.createElement(Icon_1.Icon, { key: 'remove-icon', className: 'fa-trash-alt' }), color: 'red', className: 'text-left', text: (0, translation_1.getLocalization)('userfront/project/teamMembers/removeFromProject'), onClick: function () { return removeFromProject(props, removeAccessibleCategories); } }))),
        React.createElement(FilterRow, { setFeature: props.setFeature, featureFilter: props.members.featureFilter, searchString: props.searchString, searchGroups: props.searchGroups, currentProject: props.currentProject }),
        React.createElement(MemberList_1.MemberList, { translationKeys: {
                notFound: {
                    title: 'userfront/project/teamMembers/placeHolderTitle',
                    description: 'userfront/project/teamMembers/placeHolderDescription',
                    help: 'userfront/project/teamMembers/placeHolderHelp'
                }
            }, groups: props.members.groups, searchString: props.members.searchString, featureFilter: props.members.featureFilter, isCollapsed: props.members.isCollapsed, selectedUsers: props.members.selectedUsers, selectedGroups: props.members.selectedGroups, status: props.members.status, sortingAndPagination: props.members.sortingAndPagination, permission: props.currentProject.perm, fetch: function () { return props.fetchProjectUserGroups(props.currentProject.id); }, setUsersSelected: props.setUsersSelected, setGroupsSelected: props.setGroupsSelected, collapseUserRow: props.collapseUserRow, setWarningModal: props.setWarningModal, deleteGroup: hasAnyOfGrants(props.currentProject.perm, [
                acl.PROJECT_ADMIN_GRANT | acl.SOKOBID_ADMIN_GRANT
            ])
                ? function (x) { return props.deleteGroup(props.currentProject, x); }
                : undefined, deleteUsers: ((props.currentProject.perm & acl.PROJECT_ADMIN_GRANT) |
                acl.LIGHT_ADMIN_GRANT) !==
                0
                ? function (x, y) { return props.deleteUsers(props.currentProject, x.id, y); }
                : undefined, editGroup: hasAnyOfGrants(props.currentProject.perm, [
                acl.PROJECT_ADMIN_GRANT | acl.SOKOBID_ADMIN_GRANT
            ])
                ? props.editGroup
                : undefined, openUserSettingsModal: ((props.currentProject.perm & acl.PROJECT_ADMIN_GRANT) |
                acl.LIGHT_ADMIN_GRANT) !==
                0
                ? function (user) {
                    return props.openUserSettingsModal(user, props.currentProject.id, props.currentUser.fold('NormalUserGroup', function (x) { return x.level; }));
                }
                : undefined, setSortingSelector: props.setSortingSelector, disabled: {
                customerCategoryGroup: { edit: true },
                customerUserGroup: true,
                customerUserGroupUsers: true
            } }),
        React.createElement(sok_ui_1.RequestStatusBox, { key: 'request', className: 'is-saving-status-box', status: props.members.isSaving, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
            (0, translation_1.getLocalization)('userfront/project/teamMembers/saving'),
            (0, translation_1.getLocalization)('userfront/project/teamMembers/saved'),
            (0, translation_1.getLocalization)('userfront/project/teamMembers/failed')),
        React.createElement(sok_ui_1.RequestStatusBox, { key: 'request', className: 'is-saving-status-box', status: props.members.createEditModal.isSaving, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
            (0, translation_1.getLocalization)('userfront/project/teamMembers/saving'),
            (0, translation_1.getLocalization)('userfront/project/teamMembers/saved'),
            (0, translation_1.getLocalization)('userfront/project/teamMembers/failed')),
        props.members.createEditModal.status === 'CREATE' && (React.createElement(CreateGroup_1.default, { currentProject: props.currentProject })),
        props.members.createEditModal.status === 'EDIT' && (React.createElement(EditGroup_1.default, { currentProject: props.currentProject })),
        (props.currentProject.perm & acl.CUSTOMER_ADMIN_GRANT) > 0 && (React.createElement(LinkCustomerGroupModal_1.default, { currentProject: props.currentProject })),
        React.createElement(GenericInviteModal_1.default, { isOpen: props.members.invite.isOpen, modalTitle: (0, translation_1.getLocalization)('invite/member'), message: message, status: props.members.invite.status, inviteRows: props.members.invite.inviteRows, items: accessibleCategories.reduce(function (prev, curr) {
                prev.push(__assign(__assign({}, curr.category), { name: (0, userGroups_1.getLocalizedUserGroupName)(curr.category.name), disabled: curr.category.type === 'LightAdminCategoryUserGroup' ||
                        curr.category.type === 'CategoryUserGroup' ||
                        curr.category.type === 'SokoBidCategoryUserGroup' ||
                        curr.category.type === 'WorksiteDiaryUserGroup' ||
                        curr.category.type === 'TRMVRUserGroup' }));
                curr.groups.forEach(function (g) {
                    g.name = (0, userGroups_1.getLocalizedUserGroupName)(g.name);
                    return prev.push(g);
                });
                return prev;
            }, []), toggleModal: props.toggleInviteModal, selectItem: props.selectItem, updateLanguage: props.updateLanguage, updateEmails: props.updateEmails, addNewRow: props.addNewRow, inviteText: (0, translation_1.getLocalization)('components/modals/genericInvitationModal/invite'), sendInvitations: props.sendInvitations(props.members.invite.inviteRows, props.currentProject), addNewToast: props.addNewToast, errors: props.members.invite.errors, removeRow: props.removeRow, groupStatus: props.members.status, exportAddress: "".concat(__APIBASEURL__, "api/project/").concat(props.currentProject.id, "/members") }),
        React.createElement(MoveUserToGroup_1.default, { isOpen: props.members.moveUserModal, status: props.members.moveStatus, groups: accessibleCategories, users: props.members.selectedUsers.filter(function (x) {
                return props.members.moveOrCopy === 'MOVE'
                    ? x.group.type !== 'CustomerUserGroup' &&
                        x.group.type !== 'CustomerCategoryUserGroup'
                    : x.group.type !== 'CustomerCategoryUserGroup';
            }), onSave: props.saveMoveUsersToGroup(props.currentProject), onUserRemove: function (user, group) {
                return group && props.setUsersSelected([{ user: user, group: group }], false);
            }, onClose: function () { return props.toggleMoveUserToGroupModal('MOVE'); }, moveOrCopy: props.members.moveOrCopy }),
        React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.warningModal !== null, close: function () { return props.setWarningModal(null); }, header: (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
                React.createElement(ConfirmDialog_1.Exclamation, null),
                React.createElement("div", null,
                    React.createElement("div", { className: 'title please-confirm-text' },
                        React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                    React.createElement("div", { className: 'text' }, ((props.warningModal && props.warningModal.content) || []).map(function (x, index) { return (React.createElement("p", { key: "".concat(index) }, x)); })))), footer: React.createElement(React.Fragment, null,
                React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                        if (props.warningModal) {
                            props.warningModal.action();
                            props.setWarningModal(null);
                        }
                    } }),
                React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setWarningModal(null); } })) })));
});
